module.exports = __webpack_public_path__ + "static/img/szjj.e9bde48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szjj.png
// module id = DIr3
// module chunks = 0